import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What WooCommerce security measures do you implement?",
    answer: `<p>Our WooCommerce web design agency deploys PCI-DSS compliant payment gateways, SSL certificates, and regular security audits to safeguard your site and customer data.</p>`,
  },
  {
    question: "How do you optimize WooCommerce sites for performance?",
    answer: `<p>We use advanced caching, image optimization, and code minification techniques to reduce load times and improve overall site speed.</p>`,
  },
  {
    question:
      "Can you integrate WooCommerce with our existing CRM and ERP systems?",
    answer: ` <p>Yes, our WooCommerce web development company specialize in API-driven integrations that connect WooCommerce with CRMs, ERPs, and other business tools for seamless data flow.</p>`,
  },
  {
    question: "How do you handle abandoned cart recovery?",
    answer: `<p>We implement automated email campaigns and exit-intent popups that target users who leave items in their cart, helping you recover lost sales.</p>`,
  },
  {
    question: "What ongoing support do you offer after the site goes live?",
    answer: `<p>We provide continuous monitoring, security updates, and performance tuning to ensure your WooCommerce site remains secure and high-performing.</p>`,
  },
  {
    question: "Do you offer custom plugin development for WooCommerce?",
    answer: ` <p>Yes, WooCommerce website design agency creates tailored WooCommerce plugins to extend your site’s functionality and meet specific business requirements.</p>`,
  },
  {
    question: "How do you ensure WooCommerce is SEO-optimized?",
    answer: ` <p>We implement WooCommerce-specific SEO strategies, including optimized product pages, schema markup, and technical SEO audits, to improve search rankings.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>WooCommerce</span> Web Development FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
